import { render, staticRenderFns } from "./BreadcrumbsSelector.vue?vue&type=template&id=775512c8&scoped=true"
import script from "./BreadcrumbsSelector.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbsSelector.vue?vue&type=script&lang=ts"
import style0 from "./BreadcrumbsSelector.vue?vue&type=style&index=0&id=775512c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775512c8",
  null
  
)

export default component.exports